var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoDiscover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vrstva_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "40px",
    height: "40px",
    viewBox: "1230 1230 40 40",
    enableBackground: "new 1230 1230 40 40",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FBBC01",
    d: "M1233.759,1238.004l8.994,8.994H1230v5.991h12.753l4.343-4.313v-6.02l-8.994-8.994L1233.759,1238.004z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EB4435",
    d: "M1247.023,1248.646l10.338-1.636l8.994-8.994l-4.344-4.343l-8.993,8.994V1230h-5.99L1247.023,1248.646z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#38A752",
    d: "M1233.695,1261.979l4.344,4.346l8.993-8.999V1270h5.99v-12.674l-5.999-8.681L1233.695,1261.979z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4886F4",
    d: "M1246.991,1251.313l14.989,14.984l4.345-4.344l-8.997-8.994H1270v-5.99h-20.927 C1246.257,1247.506,1246.302,1249.678,1246.991,1251.313L1246.991,1251.313z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDiscover);
export default __webpack_public_path__ + "static/media/logo-discover.b9720fa2105588e02b563ff3ea7c298b.svg";
export { ForwardRef as ReactComponent };